/**
 * 入札一覧 (AC-BIN-003) の入札価格・入札量の列と同じ表示。 札の概要 (取消確認・結果の通知) と
 * 一部の札が通らなかった時の詳細の表も、 この桁で出す。
 */

/** 入札価格 (円/kWh)。 小数 2 桁に揃える。 */
export const formatBidPrice = (priceYenPerKwh: string): string =>
  Number(priceYenPerKwh).toFixed(2)

/** 入札量 (MW)。 末尾の 0 は落とす (`10.0` → `10`)。 */
export const formatBidVolumeMw = (volumeMw: string): number => Number(volumeMw)
